// extracted by mini-css-extract-plugin
export default {"formContainer":"ListPetsQR_formContainer__taX0k"};